export default {
  'cost:perOrder-rf': 'costPerOrder-rf',
  'cost:perOrderLast-rf': 'costPerOrderLast-rf',
  'cost:perOrder-divvit-rf': 'costPerOrder-divvit-rf',
  'cost:perOrder-ftd': 'costPerOrder-ftd',
  'cost:perOrderLast-ftd': 'costPerOrderLast-ftd',
  'cost:perOrder-divvit-ftd': 'costPerOrder-divvit-ftd',
  'order:count-last-click': 'orderCount',
  'order:count': 'orderCount',
  'order:count-divvit': 'orderCount',
  'order:total-last-click': 'orderCount',
  'order:total': 'orderCount',
  // 'order:total-divvit': 'orderCount',
  'session:count': 'traffic',
  'cost:total': 'cost',
  'cost:perVisit': 'costPerVisit',
  'cost:perVisit-last-click': 'costPerVisitLast',
  'cost:perVisit-divvit': 'costPerVisitDivvit',
  'order:count-non-direct-touch': 'orderCount',
  'order:count-non-direct-last-click': 'orderCount',
  'order:count-non-direct-clicks': 'orderCount',
  'order:count-non-direct-last-touch': 'orderCount'
}



// WEBPACK FOOTER //
// ./client/redux/modules/insights/metricNames.js